import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import Bucket from './Bucket';

const Facet = ({ facet, selectedFacetValues, onToggleFacet, wedding }) => {
  if (!facet.buckets || facet.buckets.length === 0) return null;

  return (
    <div key={facet.key} className="facet">
      <div className="form-label">{facet.label}</div>
      <ul className="list-unstyled">
        {facet.buckets && facet.buckets.map(facetValue => (
          <Bucket key={facetValue.key} facet={facet} facetValue={facetValue} selectedFacetValues={selectedFacetValues} onToggleFacet={onToggleFacet} wedding={wedding} />
        ))}
      </ul>
    </div>
  );
};


Facet.propTypes = {
  facet: PropTypes.shape({}),
  onToggleFacet: PropTypes.func.isRequired,
  selectedFacetValues: PropTypes.shape({}),
  wedding: PropTypes.shape({})
};

const FacetList = ({ facets, selectedFacetValues, onToggleFacet, onResetFacets, wedding }) => {
  const objectValues = selectedFacetValues !== undefined ? Object.values(selectedFacetValues) : undefined;
  const formattedArray = _.remove(objectValues, (idx) => { return idx.length !== 0; }); // eslint-disable-line

  return (
    <div className="facets">
      <div>
        {formattedArray.length !== 0 ? (
          <a role="button" className="pull-right" onClick={onResetFacets}>Clear</a>
        ) : (
          null
        )}
        {facets.map(facet => (
          <Facet key={facet.key} facet={facet} selectedFacetValues={selectedFacetValues} onToggleFacet={onToggleFacet} wedding={wedding} />
        ))}
      </div>
    </div>
  );
};

FacetList.propTypes = {
  facets: PropTypes.arrayOf(PropTypes.shape({})),
  selectedFacetValues: PropTypes.shape({}),
  onToggleFacet: PropTypes.func.isRequired,
  onResetFacets: PropTypes.func.isRequired,
  wedding: PropTypes.shape({})
};

const mapStateToProps = state => ({
  facets: state.guestList.guests.facets,
  selectedFacetValues: state.guestList.guests.selectedFacetValues,
  wedding: state.wedding.wedding
});

export default connect(
  mapStateToProps
)(FacetList);



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/Facets.jsx